module.exports = __webpack_public_path__ + "images/feature/20150709_02-dbc6df8647d0cae83aae33001d34d0c5.png";